export const ConvermaxSecondaryMedia = class extends window.HTMLElement {
  constructor() {
    super();

    setTimeout(() => {
      window.Motion.inView(
        this,
        () => {
          setTimeout(() => this.init());
        },
        { margin: '200px 0px 200px 0px' },
      );
    }, 1);
  }

  get template() {
    return this.previousElementSibling;
  }

  disconnectedCallback() {
    if (this.carousel) {
      this.carousel.destroy();
    }
  }

  init() {
    if (!this.template) {
      return;
    }

    const clonedNodes = this.template.cloneNode(true).children;

    Array.from(clonedNodes).forEach((child) => {
      this.appendChild(child.cloneNode(true));
    });
    this.mediaCount = this.querySelectorAll('.media').length;

    if (this.mediaCount > 1) {
      this.carousel = new window.Flickity(this, {
        accessibility: false,
        draggable: false,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true,
        rightToLeft: window.theme.config.rtl,
      });

      if (this.mediaCount === 2) {
        this.classList.add('without-dots');
      }

      this.addEventListener('mousemove', this.onMoveHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }
  }

  onMoveHandler(event) {
    if (this.mediaCount === 2) {
      return this.carousel.select(1);
    }

    const { width } = this.carousel.size;
    const mouseX = event.clientX - this.getBoundingClientRect().left;

    if (this.mediaCount === 3) {
      if (mouseX < width / 2) {
        return this.carousel.select(1);
      }
      return this.carousel.select(2);
    }

    if (this.mediaCount === 4) {
      if (mouseX < width / 3) {
        return this.carousel.select(1);
      }
      if (mouseX < (2 * width) / 3) {
        return this.carousel.select(2);
      }
      return this.carousel.select(3);
    }
  }

  onLeaveHandler() {
    this.carousel.select(0);
  }
};
